import { httpRequest } from "@/utils/HttpRequest";
import { IPage } from "@/types/ScmTypes";
import {
    ApprovalShopFields,
    OrgFields,
    UserFields,
    ApprovalFlowFields,
    ApprovalFlowInsertFields,
    ApprovalFlowUpdateFields,
} from "./ApprovalTypes";

class ApprovalService {

    async getApprovalShop() {
        const apiUrl = `/zzw-vrm/approval_flow/getApprovalShop`;
        return await httpRequest.get<ApprovalShopFields[]>(apiUrl);
    }

    async insert(param: ApprovalFlowInsertFields) {
        const apiUrl = `/zzw-vrm/approval_flow/insert`;
        return await httpRequest.post<boolean>(apiUrl, param);
    }

    async update(param: ApprovalFlowUpdateFields) {
        const apiUrl = `/zzw-vrm/approval_flow/update`;
        return await httpRequest.post<boolean>(apiUrl, param);
    }

    async delete(id: string) {
        const apiUrl = `/zzw-vrm/approval_flow/delete/${id}`;
        return await httpRequest.get<boolean>(apiUrl);
    }

    async getShopFlow(approvalType: string, shopCode: string) {
        const apiUrl = `/zzw-vrm/approval_flow/getShopFlow/${approvalType}/${shopCode}`;
        return await httpRequest.get<ApprovalFlowFields[]>(apiUrl);
    }
    async roleGroupPage() {
        const apiUrl = `/zzw-portal/auth/roleGroup/listPage`;
        return await httpRequest.post<any[]>(apiUrl);
    }
    async allOrgTree(searchVo: any) {
        const apiUrl = `/portal/org/allTree`;
        return await httpRequest.post<OrgFields[]>(apiUrl, searchVo);
    }

    async oneOrgTree(searchVo: any) {
        const apiUrl = `/portal/org/oneTree`;
        return await httpRequest.post<OrgFields>(apiUrl, searchVo);
    }

    async getUser(searchVo: any) {
        const apiUrl = `/zzw-portal/auth/role/findPage`;
        return await httpRequest.post<IPage<UserFields>>(apiUrl, searchVo);
    }

    async updateUser(param: any) {
        const apiUrl = `/portal/auth/user/update`;
        return await httpRequest.post<boolean>(apiUrl, param);
    }

}

export const approvalService = new ApprovalService();
